import { HttpClient, HttpErrorResponse, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { throwError as observableThrowError, Observable } from 'rxjs';
import { catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuditMonthService {

  AppUrl: string = "";

  constructor(private readonly _http: HttpClient) {
    this.setAPIUrl();
  }

  setAPIUrl() {
    if (sessionStorage.getItem("BaseURL") != null && sessionStorage.getItem("BaseURL") != "") {
      this.AppUrl = sessionStorage.getItem("BaseURL") || '';
    }
  }

  private handleError(error: HttpErrorResponse) {
    console.error(error.message || error);
    return observableThrowError(() => error.status);
  }

  auditMonthUpdate(TokenKey: string, updateAuditmonthModel:any): Observable<any> {
    this.setAPIUrl();
    let URL = this.AppUrl + 'api/main911/UpdateAuditmonth';
    const httpOptions = { headers: new HttpHeaders({ 'Content-Type': 'application/json', 'Token': TokenKey }) };
    return this._http.post<any>(URL, updateAuditmonthModel, httpOptions)
      .pipe(catchError(this.handleError));
  }
}
